const getTeamsUrl = (parentUrl) => {
	if (parentUrl.includes('localhost:3000')) {
		return 'http://localhost:5011';
	}

	if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
		return 'https://staging-teams.chekkit.io';
	}

	if (parentUrl.includes('evanov') || parentUrl.includes('radio')) {
		return 'https://teams2.chekkit.io';
	}

	return 'https://teams.chekkit.io';
};

export default getTeamsUrl;
